import { environmentVars } from 'constants/services';

const commonAccountNames = {
  box: 'Box',
  dropbox: 'Dropbox',
  sharepoint: 'SharePoint',
  googledrive: 'Google Drive',
  studio: 'Studio Projects',
  egnyte: 'Egnyte',
  onedrive: 'OneDrive',
};

export const accountNames = {
  full: {
    ...commonAccountNames,
  },
  short: {
    ...commonAccountNames,
  },
};

export const integrationsPageText = {
  sharepoint: {
    authUrl: `${environmentVars.OAUTH_AUTH_URL}/sharepoint`,
    providerName: 'sharepoint',
    title: 'SharePoint Online',
    learnMore: {
      textLink: 'sharepoint.com',
      link: 'https://sharepoint.com',
    },
  },
  box: {
    authUrl: `${environmentVars.OAUTH_AUTH_URL}/box`,
    providerName: 'box',
    title: 'Box',
    learnMore: {
      textLink: 'box.com',
      link: 'https://box.com',
    },
  },
  onedrive: {
    authUrl: `${environmentVars.OAUTH_AUTH_URL}/onedrive`,
    providerName: 'onedrive',
    title: 'OneDrive',
    learnMore: {
      textLink: 'onedrive.live.com',
      link: 'https://onedrive.live.com',
    },
  },
  dropbox: {
    authUrl: `${environmentVars.OAUTH_AUTH_URL}/dropbox`,
    providerName: 'dropbox',
    title: 'Dropbox',
    learnMore: {
      textLink: 'dropbox.com',
      link: 'https://dropbox.com',
    },
  },
  googledrive: {
    authUrl: `${environmentVars.OAUTH_AUTH_URL}/googledrive`,
    providerName: 'googledrive',
    title: 'Google Drive',
    learnMore: {
      textLink: 'google.com/drive',
      link: 'https://google.com/drive/',
    },
  },
  egnyte: {
    authUrl: `${environmentVars.OAUTH_AUTH_URL}/egnyte`,
    providerName: 'egnyte',
    title: 'Egnyte',
    learnMore: {
      textLink: 'egnyte.com',
      link: 'https://www.egnyte.com/',
    },
  },
  technicalSupportLink: 'https://support.bluebeam.com/contact/',
};
